document.addEventListener('DOMContentLoaded', function () {
	const sliders = document.querySelectorAll('.enable-slider');

	function initSlider(sliders) {
		sliders.forEach((container) => {
			const wrapper = container.querySelector('.wc-block-product-template__responsive');
			const items = container.querySelectorAll('.wc-block-product');

			if (!wrapper || items.length === 0) return;

			// Read settings safely from dataset
			const settings = {
				perViewDesktop: parseFloat(container.dataset.perViewDesktop) || 4,
				perViewTablet: parseFloat(container.dataset.perViewTablet) || 2,
				perViewMobile: parseFloat(container.dataset.perViewMobile) || 1,
				showPagination: container.dataset.showPagination === 'true',
				showArrows: container.dataset.showArrows === 'true',
			};

			if (settings.perViewDesktop > items.length) return;

			// Add Swiper classes
			wrapper.classList.add('swiper-wrapper');
			items.forEach((item) => item.classList.add('swiper-slide'));

			// Create Swiper container and controls
			const swiperContainer = document.createElement('div');
			swiperContainer.classList.add('swiper');

			const pagination = document.createElement('div');
			pagination.classList.add('swiper-pagination');

			// Create next button
			const nextBtn = document.createElement('div');
			nextBtn.classList.add('slider__next');
			nextBtn.innerHTML = `
			<span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M5.93375 10.6661L15.1261 1.47371L14.419 0.766602L4.51953 10.6661L14.419 20.5656L15.1261 19.8585L5.93375 10.6661Z" fill="#211710"></path>
			</svg></sapn>`;

			// Create prev button
			const prevBtn = document.createElement('div');
			prevBtn.classList.add('slider__prev');
			prevBtn.innerHTML = `<span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M14.0663 10.6661L4.87387 1.47371L5.58097 0.766602L15.4805 10.6661L5.58097 20.5656L4.87387 19.8585L14.0663 10.6661Z" fill="#211710"></path>
			</svg></span>
			`;

			// Insert swiperContainer into the DOM and move wrapper inside it
			wrapper.parentNode.insertBefore(swiperContainer, wrapper);
			swiperContainer.appendChild(wrapper);

			// Append pagination and arrows into swiperContainer (after wrapper is inside)
			if (settings.showPagination) {
				swiperContainer.appendChild(pagination);
			}
			if (settings.showArrows) {
				swiperContainer.appendChild(prevBtn);
				swiperContainer.appendChild(nextBtn);
			}

			// Initialize Swiper
			new Swiper(swiperContainer, {
				navigation: {
					nextEl: '.slider__next',
					prevEl: '.slider__prev',
				},
				slidesPerView: settings.perViewDesktop,
				spaceBetween: 12,
				centeredSlides: false,
				loop: true,
				pagination: settings.showPagination
					? { el: pagination, clickable: true }
					: false,
				navigation: settings.showArrows
					? { nextEl: nextBtn, prevEl: prevBtn }
					: false,
				breakpoints: {
					0: {
						slidesPerView: settings.perViewMobile,
					},
					768: {
						slidesPerView: settings.perViewTablet,
					},
					1440: {
						slidesPerView: settings.perViewDesktop,
					}
				}
			});
		});
	}

	let swiperInstance = null;
	const breakpoint = 1024; // Disable Swiper at 1024px and up

	function handleSwiper() {
		const screenWidth = window.innerWidth;
		if (screenWidth > breakpoint && !swiperInstance) {
			initSlider(sliders);
		}
	}

	window.addEventListener('load', handleSwiper);
	window.addEventListener('resize', handleSwiper);


});
